export enum AuthStatus {
  Pending = "PENDING",
  Authenticated = "AUTHENTICATED",
  Unauthenticated = "UNAUTHENTICATED",
}

export type AuthTokens = {
  accessToken: string | null;
  refreshToken: string | null;
};

export type AuthState = AuthTokens & {
  status: AuthStatus;
};
